var EmergencyStatuses = new Enum({
  Found: 1,
  Informed: 2,
  Liquidation: 3,
  Liquidated: 4
});
